import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {resetUserMfa} from 'src/openapi/admin/apis/UserAuthenticationInfoApi';
import {useAppDispatch} from 'src/store/hooks';

import type {ErrorPayload} from 'src/typedef';

type Props = {
    userId?: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useResetUserMfa = ({userId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => {
        if (userId) {
            return apiDispatch(resetUserMfa({userId}));
        } else {
            return Promise.resolve({
                type: '',
                payload: {
                    data: {message: 'Auth User ID is not provided'},
                    success: false,
                    error: true,
                } as ErrorPayload,
            });
        }
    }, [userId, apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
